// {
//   "name": "iconic-collection-list-fifth.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-collection-list-fifth')) {
    return;
  }

  class Collectionfifth extends HTMLElement {
    constructor() {
      super();
    }

   /*CUSTOM CODE: Edits for hiding the "all" tab*/
    
        /* ORIGINAL: CODE:
        connectedCallback() {
          this.initCollectionfifth();
          window.addEventListener('resize', () => this.setupScrollBar());
        } */
    
/* Custom code to move "all" to end" */
    connectedCallback() {
    this.initCollectionfifth();
    window.addEventListener('resize', () => this.setupScrollBar());

    // Move "All" tab to the end of the list (or hide it)
    const allTab = this.querySelector('.iconic-list-titles'); // Assuming it's the first tab
    const tabList = this.querySelector('.iconic-scroll-content'); // The container holding the tabs
    if (allTab && tabList) {
        // Move or hide the "All" tab
        tabList.appendChild(allTab); // Move to the end
        // allTab.style.display = 'none'; // Uncomment this if you want to hide it instead
    }

    // Automatically select the first non-"All" tab
    const firstVisibleTab = this.querySelector('.iconic-list-titles:not([style*="display: none"])');
    if (firstVisibleTab) {
        firstVisibleTab.classList.add('iconic-active-category');
        this.showSection(firstVisibleTab.dataset.sectionNumber, { target: firstVisibleTab });
    }

}
    /* END custom code */
    
    initCollectionfifth() {
      this.setupSectionClickHandlers();
      this.setupScrollBar();
    }

    setupSectionClickHandlers() {
      const buttons = this.querySelectorAll('.iconic-list-titles');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const sectionNumber = button.dataset.sectionNumber;
          this.showSection(sectionNumber, event);
        });
      });
    }

    showSection(sectionNumber, event) {
      const sectionMain = this.querySelector(`#block-${sectionNumber}`);
      if (sectionMain) {
        const mainParentButtons = event.target.closest('.iconic-scroll-content');
        const hideButtons = mainParentButtons.querySelectorAll('.iconic-list-titles');
        hideButtons.forEach((btn) => btn.classList.remove('iconic-active-category'));
        event.target.classList.add('iconic-active-category');

        const mainParent = event.target.closest('.iconic-row');
        const hideOthers = mainParent.querySelectorAll('.iconic-cards-main');
        hideOthers.forEach((block) => {
          if (block.classList.contains(`block-${sectionNumber}`)) {
            block.classList.remove('iconic-d-none');
          } else {
            block.classList.add('iconic-d-none');
          }
        });
      }
    }

    setupScrollBar() {
      const scrollContainer = this.querySelector('.iconic-scroll-content');
      const leftArrow = this.querySelector('.iconic-scroll-left');
      const rightArrow = this.querySelector('.iconic-scroll-right');

      if (!scrollContainer || !leftArrow || !rightArrow) return;

      leftArrow.classList.remove('iconic-d-none');
      rightArrow.classList.remove('iconic-d-none');

      leftArrow.addEventListener("click", () => this.scrollLeft(scrollContainer, leftArrow, rightArrow));
      rightArrow.addEventListener("click", () => this.scrollRight(scrollContainer, leftArrow, rightArrow));
      scrollContainer.addEventListener('scroll', () => this.checkScrollButtons(scrollContainer, leftArrow, rightArrow));
      scrollContainer.addEventListener('wheel', (event) => this.handleWheelScroll(event, scrollContainer));
      this.checkScrollButtons(scrollContainer, leftArrow, rightArrow);
    }

    scrollLeft(scrollContainer, leftArrow, rightArrow) {
      const itemWidth = this.querySelector('.iconic-list-titles').offsetWidth;
      const itemScroll = itemWidth * 5;
      scrollContainer.scrollBy({ left: -itemScroll, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(scrollContainer, leftArrow, rightArrow), 300);
    }

    scrollRight(scrollContainer, leftArrow, rightArrow) {
      const itemWidth = this.querySelector('.iconic-list-titles').offsetWidth;
      const itemScroll = itemWidth * 5;
      scrollContainer.scrollBy({ left: itemScroll, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(scrollContainer, leftArrow, rightArrow), 300);
    }

    handleWheelScroll(event, scrollContainer) {
      event.preventDefault();
      scrollContainer.scrollBy({ left: event.deltaY * 2, behavior: 'smooth' });
    }

    checkScrollButtons(scrollContainer, leftArrow, rightArrow) {
      if (scrollContainer.scrollLeft > 0) {
        leftArrow.classList.remove('iconic-d-none');
      } else {
        leftArrow.classList.add('iconic-d-none');
      }

      if (scrollContainer.scrollLeft + scrollContainer.clientWidth < scrollContainer.scrollWidth) {
        rightArrow.classList.remove('iconic-d-none');
      } else {
        rightArrow.classList.add('iconic-d-none');
      }
    }
  }

  customElements.define('iconic-collection-list-fifth', Collectionfifth);
})();